interface SunAccentProps {
  className?: string;
  circleClassName?: string;
  iconClassName?: string;
  glow?: boolean;
  label?: string;
}

/**
 * The single deliberate golden-green "sprout" moment used once per major section.
 * A soft chartreuse-green medallion that carries dark icon text so it stays crisp —
 * a small, fresh hint of the brand accent rather than a hard, dominating gold.
 */
export default function SunAccent({
  className = "",
  circleClassName = "w-8 h-8",
  iconClassName = "text-base",
  glow = true,
  label,
}: SunAccentProps) {
  return (
    <span
      className={`relative inline-flex items-center justify-center shrink-0 ${className}`}
      aria-hidden="true"
    >
      {glow && (
        <span className="absolute inset-0 rounded-full bg-accent-400/25 blur-sm" />
      )}
      <span
        className={`relative flex items-center justify-center rounded-full bg-accent-400/90 text-accent-950 ${circleClassName}`}
      >
        <i className={`ri-leaf-line ${iconClassName}`}></i>
      </span>
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}